import { isCancel } from "axios";

/** Plain Error message used by the collaboration API interceptor after normalizing axios cancel/abort. */
export const CANCELED_REQUEST_ERROR_MESSAGE = "Request canceled or aborted";

function isAbortError(error: unknown): boolean {
  return (
    typeof error === "object" && error !== null && "name" in error && error.name === "AbortError"
  );
}

function isCanceledErrorShape(error: unknown): boolean {
  if (typeof error !== "object" || error === null) {
    return false;
  }
  const { name, code } = error as { name?: unknown; code?: unknown };
  return name === "CanceledError" || code === "ERR_CANCELED";
}

function getErrorMessage(error: unknown): string | undefined {
  if (typeof error === "string") {
    return error;
  }
  if (typeof error === "object" && error !== null && "message" in error) {
    const { message } = error as { message?: unknown };
    return typeof message === "string" ? message : undefined;
  }
  return undefined;
}

function isCanceledErrorMessage(message: string): boolean {
  const normalized = message.trim().toLowerCase();
  return (
    normalized === "canceled" ||
    normalized === "request canceled" ||
    message === CANCELED_REQUEST_ERROR_MESSAGE ||
    message.includes("Request aborted") ||
    normalized === "the user aborted a request." ||
    normalized === "signal is aborted without reason" ||
    /uncaught \(in promise\).*canceled/.test(normalized)
  );
}

/** User navigation, inactive-tab aborts, or explicit axios cancel. */
export function isCanceledOrAbortedRequest(error: unknown): boolean {
  if (isCancel(error) || isAbortError(error) || isCanceledErrorShape(error)) {
    return true;
  }
  const message = getErrorMessage(error);
  return message !== undefined && isCanceledErrorMessage(message);
}
